import {findInArr} from './utils';

export default class SortComponent {
  constructor(settings) {

    this.settings = settings;

    this.domEl = document.createElement('div');
    this.domEl.className = 'cmp-sort';
    this.domEl.addEventListener('click', event => this.clickHandler(event));

    this.init();
  };


  init(activeSort) {
    this.domEl.innerHTML = '';

    this.settings.sortTypes.forEach(item => item.active = item.type === activeSort);

    this.settings.sortTypes.forEach(item => {

      let a = document.createElement('div');
      a.className = 'cmp-sort__item';
      a.innerHTML = item.name;
      a.setAttribute('data-type', item.type);

      if (item.active) {
        this.currentSortType = item.type;
        a.className += ' cmp-sort__item_active';
      }

      this.domEl.appendChild(a);

    });

    if (this.settings.renderTo) this.renderTo(this.settings.renderTo);
  }


  get template() {
    return this.domEl;
  }


  renderTo(domWrap) {

    domWrap.appendChild(this.domEl);

  }


  setActive(domElement) {
    this.domEl.childNodes.forEach(childNode => {
      childNode.className = 'cmp-sort__item';
      if (childNode === domElement) childNode.className += ' cmp-sort__item_active';
    });
  }


  get sortType() {
    return this.currentSortType;
  }


  clickHandler(event) {
    if (this.disable) return false;

    const path = event.path || (event.composedPath && event.composedPath());

    if (path) {
      path.forEach(item => {

        if (item.className === 'cmp-sort__item') {
          let sortType = item.getAttribute('data-type');

          this.currentSortType = sortType;
          this.setActive(item);
          this.settings.clickCallback(sortType);
        }

      });
    } else {
      const bubbleFind = (item) => {
        if (item.className === 'cmp-sort__item') {
          let sortType = item.getAttribute('data-type');

          this.currentSortType = sortType;
          this.setActive(item);
          this.settings.clickCallback(sortType);
        } else {
          bubbleFind(item.parentNode);
        }
      };

      bubbleFind(event.target);
    }
  }


  set disable(value) {
    this._disable = value;

    this.domEl.className = this._disable ? 'cmp-sort cmp-sort_disabled' : 'cmp-sort';
  }

  get disable() {
    return this._disable;
  }
}



// WEBPACK FOOTER //
// ./src/desktop/scripts/searchPageComponents/sortComponents.js